import React, {useState} from "react";
import {CreateIntentModal} from "../CreateIntentModal";
import {ListBlock} from "./ListBlock";
import {SideItemRow} from "./SideItemRow";

export const IntentBlock = ({project, onUpdateProject, getUserProjects, flow}) => {
    const [openModal, setOpenModal] = useState(false);
    const [selectedIntent, setSelectedIntent] = useState(null);
    const [search, setSearch] = useState("");

    const onUpdateIntent = async (intent) => {
        const newProject = {...project};
        const index = newProject?.intents?.findIndex((i) => i?.id === intent?.id);
        if (isFinite(index) && index >= 0) {
            newProject.intents[index] = intent;
        } else {
            newProject.intents.push(intent);
        }
        await onUpdateProject(newProject);
        await getUserProjects();
    };

    const onRemove = async (id) => {
        const newProject = {...project};
        newProject.intents = newProject?.intents?.filter((item) => item.id !== id);
        await onUpdateProject(newProject);
        await getUserProjects();
    };

    const items = project?.intents?.filter(
        (item) => item?.name?.toLowerCase()?.includes(search?.toLowerCase()),
    ) || [];

    return (
        <>
            <CreateIntentModal
                flow={flow}
                open={openModal}
                project={project}
                handleClose={() => {
                    setOpenModal(false);
                    setSelectedIntent(null);
                }}
                intent={selectedIntent}
                handleSubmit={onUpdateIntent}
                onRemove={onRemove}
            />
            <ListBlock
                title="Intents"
                items={items}
                search={search}
                onChangeSearch={setSearch}
                onCreate={() => setOpenModal(true)}
                mapItem={(intent) => (
                    <SideItemRow
                        key={intent?.id || intent?.key}
                        label={intent?.name}
                        tooltip={intent?.name}
                        onClick={() => {
                            setSelectedIntent(intent);
                            setOpenModal(true);
                        }}
                    />
                )}
            />
        </>
    );
};
